import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import { Button, InputNumber, Modal, Table } from 'antd';
// import debounce from 'lodash/debounce';
import { TableProductSelectedStyles } from '../Form/styles';
import { useEffect, useMemo, useState } from 'react';
// import findIndex from 'lodash/findIndex';
import {
  calculateShippingFeeFnc,
  getTotalAmount,
} from 'containers/OrdersReturn/utils';
// import OrderGift from '../OrderGift';
import VariantNameItem from './VariantNameItem';
import { getProductAttributesObjKeyById } from '@redux/config/selectors';
import { useSelector } from '@redux';
import { useRestContext } from 'components/form/RestInputContext';
import { formatMoney } from 'utils/formattedString';
import TableCustom from 'components/commons/TableCustom';
import { DynamicObjectType } from 'types/commons';
import { Form } from 'antd';
import _ from 'lodash';
import {
  RETURN_CHANNEL,
  RETURN_STATUS,
  RETURN_METHOD,
} from 'constants/ordersReturn';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faX } from '@fortawesome/pro-light-svg-icons';
// import { TableRowSelection } from 'antd/es/table/interface';

interface ITableProductSelectedTypes {
  variantsApplied?: DynamicObjectType[];
  products?: DynamicObjectType[];
  openVariantSelectionModal?: (value) => void;
  isLayoutEditProducts?: boolean;
}

// const getValidQuantity = (stock, value) => {
//   if (value > stock) return stock;
//   if (!stock) return 1;
//   return value;
// };

function TableProductSelected({
  products,
  isLayoutEditProducts,
}: ITableProductSelectedTypes) {
  const { t } = useTranslation();
  const { form, record } = useRestContext();
  // const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // const onChangeQuantity = (record, value) => {
  //   // eslint-disable-next-line prefer-const
  //   let matchedFormRecordIdx = findIndex(variantsApplied, ['id', record.id]);
  //   if (matchedFormRecordIdx !== -1) {
  //     form.setFields([
  //       {
  //         name: ['variantsApplied', matchedFormRecordIdx, 'quantity'],
  //         value: getValidQuantity(record?.stock, value),
  //       },
  //     ]);
  //   }
  // };

  // const onDeleteItem = (id) => {
  //   Modal.confirm({
  //     title: t('orders.delVariantConfirmTitle'),
  //     content: t('orders.delVariantConfirmDesc'),
  //     onOk() {
  //       form.setFields([
  //         {
  //           name: 'variantsApplied',
  //           value: variantsApplied?.filter((item) => item.id !== id),
  //         },
  //       ]);
  //     },
  //     className: 'confirm-modal',
  //   });
  // };

  // const debounceOnChange = debounce(onChangeQuantity, 600);

  // const onEdit = (id) => {
  //   openVariantSelectionModal(id);
  // };

  // const onChangeChooseGift = (row_id) => {
  //   if (expandedRowKeys.includes(row_id)) {
  //     setExpandedRowKeys(expandedRowKeys.filter((i) => i !== row_id));
  //   } else {
  //     setExpandedRowKeys([...expandedRowKeys, row_id]);
  //   }
  // };

  const productAttributesObjKeyById = useSelector(
    getProductAttributesObjKeyById,
  );

  const columns = useMemo(() => {
    return [
      {
        title: t('ordersReturn.products'),
        dataIndex: 'name',
        key: 'name',
        width: 500,
        render: (name, item) => (
          <VariantNameItem
            item={item}
            // expandedRowKeys={expandedRowKeys}
            // onChangeChooseGift={onChangeChooseGift}
            productAttributesObjKeyById={productAttributesObjKeyById}
          />
        ),
      },
      // {
      //   title: t('orders.quantityShort'),
      //   dataIndex: 'quantity',
      //   key: 'quantity',
      //   width: 100,
      //   render: (quantity, item) => {
      //     return (
      //       <InputNumber
      //         value={quantity}
      //         onChange={(...args) => debounceOnChange(item, ...args)}
      //         style={{ width: 70 }}
      //         min={1}
      //         // max={item.stock}
      //       />
      //     );
      //   },
      // },
      {
        title: t('ordersReturn.originalPrice'),
        dataIndex: 'originalPrice',
        key: 'originalPrice',
        width: 150,
        render: (data) => (
          <div className="text-title-gray">{formatMoney(data)}</div>
        ),
      },
      // {
      //   title: t('ordersReturn.discountPrice'),
      //   dataIndex: 'discountPrice',
      //   key: 'discountPrice',
      //   width: 150,
      //   render: (data) => (
      //     <div className="text-title-gray">{formatMoney(data)}</div>
      //   ),
      // },
      {
        title: t('ordersReturn.discountPrice'),
        dataIndex: 'erpAmount',
        key: 'erpAmount',
        width: 150,
        render: (data) => (
          <div className="text-title-gray">{formatMoney(data)}</div>
        ),
      },
      // {
      //   title: '',
      //   dataIndex: 'action',
      //   key: 'action',
      //   render: (dt, record: DynamicObjectType) => (
      //     <Button
      //       onClick={() => {
      //         onDeleteItem(record.id);
      //       }}
      //       type="text"
      //       icon={<FontAwesomeIcon icon={faX} />}
      //     />
      //   ),
      // },
    ];
  }, [productAttributesObjKeyById]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    const productsSelect = _.map(newSelectedRowKeys, (keyPosition) => {
      const product = _.find(products, { keyPosition });
      return product ? product : null;
    });
    const erpAmounts = productsSelect?.map((item) => item?.erpAmount);
    form.setFieldValue('items', productsSelect);
    form.setFieldValue('totalItem', newSelectedRowKeys?.length);
    // form.setFieldValue('totalRefund', getTotalAmount(discountPrices));
    form.setFieldValue('subTotalRefund', getTotalAmount(erpAmounts));
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    // selections: [
    //   Table.SELECTION_ALL,
    //   Table.SELECTION_INVERT,
    //   Table.SELECTION_NONE,
    //   {
    //     key: 'odd',
    //     text: 'Select Odd Row',
    //     onSelect: (changeableRowKeys) => {
    //       let newSelectedRowKeys = [];
    //       newSelectedRowKeys = changeableRowKeys.filter((_, index) => {
    //         if (index % 2 !== 0) {
    //           return false;
    //         }
    //         return true;
    //       });
    //       setSelectedRowKeys(newSelectedRowKeys);
    //     },
    //   },
    //   {
    //     key: 'even',
    //     text: 'Select Even Row',
    //     onSelect: (changeableRowKeys) => {
    //       let newSelectedRowKeys = [];
    //       newSelectedRowKeys = changeableRowKeys.filter((_, index) => {
    //         if (index % 2 !== 0) {
    //           return true;
    //         }
    //         return false;
    //       });
    //       setSelectedRowKeys(newSelectedRowKeys);
    //     },
    //   },
    // ],
  };

  useEffect(() => {
    if (Array.isArray(record?.items) && record?.items?.length > 0) {
      const extractId = _.map(record?.items, (item) => {
        const keyPosition = item?.keyPosition;
        const product = _.find(products, { keyPosition });
        return product ? product?.keyPosition : null;
      });

      onSelectChange(extractId);
    } else {
      const extractId = products?.map((item) => item?.keyPosition);
      onSelectChange(extractId);
    }

    // record?.whoPayShippingFee &&
    //   form.setFieldValue('whoPayShippingFee', record?.whoPayShippingFee);
    // record?.returnMethod &&
    //   form.setFieldValue('returnMethod', record?.returnMethod);
  }, [record, products]);

  return (
    <TableProductSelectedStyles>
      <TableCustom
        className="p-0"
        isResetStyle
        xScroll={700}
        // data={variantsApplied}
        data={products}
        columns={columns}
        rowKey="keyPosition"
        pagination={{ hideOnSinglePage: true }}
        // expandable={{
        //   showExpandColumn: false,
        //   expandedRowRender: (record) => {
        //     const matchedFormRecordIdx =
        //       findIndex(variantsApplied, ['id', record.id]) || 0;
        //     return (
        //       <OrderGift
        //         giftPromotion={record?.giftPromotion}
        //         name={['variantsApplied', matchedFormRecordIdx, 'gift']}
        //       />
        //     );
        //   },
        // }}
        // expandedRowKeys={expandedRowKeys}
        rowSelection={
          !record?.orderId ||
          (record?.status === RETURN_STATUS['AWAITING_APPROVAL'].value &&
            isLayoutEditProducts)
            ? rowSelection
            : null
        }
      />
      <Form.Item name="items" hidden />
      <Form.Item name="subTotalRefund" hidden />
      <Form.Item name="totalItem" hidden />
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          prevValues.totalItem !== curValues.totalItem ||
          // prevValues.whoPayShippingFee !== curValues.whoPayShippingFee ||
          prevValues.returnMethod !== curValues.returnMethod ||
          prevValues.subTotalRefund !== curValues.subTotalRefund ||
          prevValues.reason !== curValues.reason ||
          prevValues.returnType !== curValues.returnType
        }
      >
        {({ getFieldValue }) => {
          const reason = record?.reason || getFieldValue('reason');
          const returnType = record?.returnType || getFieldValue('returnType');
          const subTotalRefund = getFieldValue('subTotalRefund');
          // const whoPayShippingFee = getFieldValue('whoPayShippingFee');
          const returnMethod =
            record?.returnMethod || getFieldValue('returnMethod');
          const shippingFree =
            returnMethod === RETURN_METHOD['PICKUP'].value &&
            returnType === RETURN_CHANNEL['ONLINE'].value
              ? calculateShippingFeeFnc(reason)
              : 0;
          const totalItem = record?.totalItem || getFieldValue('totalItem');

          const getSummaryData = () => {
            if (
              record?.status &&
              !isLayoutEditProducts &&
              !record?.exchangeId
            ) {
              return [
                {
                  label: t('ordersReturn.totalItems'),
                  value: totalItem || 0,
                },
                {
                  label: t('ordersReturn.subtotal'),
                  value: formatMoney(
                    Number(record?.totalRefund) + shippingFree,
                  ),
                },
                {
                  label: t('ordersReturn.shippingFee'),
                  value: formatMoney(shippingFree),
                },
                {
                  label: t('ordersReturn.appliedGiftCard'),
                  value: formatMoney(record?.order?.totalAmountGiftCard),
                },
                {
                  label: t('ordersReturn.paidAmount'),
                  value: formatMoney(
                    Math.max(
                      0,
                      Number(record?.order?.total) -
                        Number(record?.order?.shippingFee),
                    ),
                  ),
                },
                {
                  label: t('ordersReturn.refundAmount'),
                  value: formatMoney(record?.totalRefund),
                },
              ];
            } else if (record?.exchangeId) {
              return [
                {
                  label: t('ordersReturn.totalItems'),
                  value: totalItem || 0,
                },
                {
                  label: t('ordersReturn.subtotal'),
                  value: formatMoney(subTotalRefund),
                },
              ];
            } else {
              return [
                {
                  label: t('ordersReturn.totalItems'),
                  value: totalItem || 0,
                },
                {
                  label: t('ordersReturn.subtotal'),
                  value: formatMoney(subTotalRefund),
                },
                {
                  label: t('ordersReturn.shippingFee'),
                  value: formatMoney(shippingFree),
                },
              ];
            }
          };

          return (
            <>
              {getSummaryData().map((item, index) => (
                <div
                  key={`summary-${index.toString()}`}
                  className="d-flex space-between mt-4"
                >
                  <span className="fw-500">{item?.label}</span>
                  <span className="fw-500">{item?.value}</span>
                </div>
              ))}
            </>
          );
        }}
      </Form.Item>
    </TableProductSelectedStyles>
  );
}

TableProductSelected.propTypes = {
  variantsApplied: PropTypes.array,
};

export default TableProductSelected;
